import classes from "./FormCard.module.scss";

const FormCard = ({ children, className }) => {
  return <div className={`${classes.formCard} ${className}`}>{children}</div>;
};

export default FormCard;
